import type { ReactNode } from 'react';

/** Reason codes that keep plan cards visible with actions in a view-only mode (Angular parity). */
export const VIEW_ONLY_REASON_CODES = new Set([
  'NOT_WITHIN_ELIGIBILITY_PERIOD',
  'BREACH_COMPLIMENTARY_LIMITED_OFFER_CHANGE_SCHEDULED',
]);

/** Transient states after plan/payment change — show processing copy, not empty offers. */
export const PROCESSING_REASON_CODES = new Set([
  'NO_PAYMENT',
  'PLAN_CHANGING',
  'OFFER_CHANGING',
  'HAS_PENDING_INACTIVE',
  'PLAN_INITIAL_ACTIVATION',
]);

/**
 * Copy aligned with `identityWeb` `my-account:planDetails.errorMessages` (en).
 *
 * Elevated out of `pages/offers-and-upgrades/partials/full-plan-view/` when the
 * membership-cancellation module became a second consumer: Angular renders these
 * same two strings on Billing details as well as My Plan
 * (`billing-term.component.html:198,203` and `plan-details.component.html:104,109`),
 * so BRD FR-055 needs one shared source rather than a second copy of the wording.
 */
export const INELIGIBILITY_MESSAGES: Record<string, ReactNode> = {
  LATE_PAYMENT: (
    <>
      You cannot modify your service because we are unable to process your
      payment. Please{' '}
      <a href='/my-account/plan-details'>update your credit card information</a>
      .
    </>
  ),
  NO_PAYMENT:
    'You cannot modify your service while we are processing your payment. You can change the plan anytime after the payment is processed.',
  PLAN_CHANGING: 'Plan update in progress. It may take some time.',
  OFFER_CHANGING: 'Plan update in progress. It may take some time.',
  HAS_PENDING_INACTIVE: 'Plan update in progress. It may take some time.',
  PLAN_INITIAL_ACTIVATION:
    'You cannot modify your service while we are setting up your account.',
  USER_CANCELLING: 'You cannot modify your service at this time.',
  USER_TRIAL_PERIOD: 'You cannot modify your service while in a trial period.',
};
